<template>
  <div>
    ATTENDANCE
    <hr>
    <b-form-group :class="{'error-input' : $v.data_attendance.title.$error}">
      <label> Attendance Title </label>
      <j-input
        v-model="$v.data_attendance.title.$model"
        :max-length="255"
        placeholder="Attendance Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeAttendance">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveAttendance">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_attendance: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_attendance: {
        title: '',
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_channel']),

    generateDataAttendance() {
      const infoName = this.data_attendance.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_attendance.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataAttendanceUpdate() {
      const infoName = this.data_attendance.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_attendance.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_attendance.title = JSON.parse(this.dataEdit.info).name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['getListWidgetDetail', 'saveWidget', 'updateWidget', 'getListChannel']),

    saveAttendance() {
      this.$v.data_attendance.$touch();
      if (!this.$v.data_attendance.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataAttendance;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataAttendanceUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeAttendance();
      }
    },

    closeAttendance() {
      this.$emit('close-field');
      this.data_attendance.channel = null;
      setTimeout(() => {
        this.$v.data_attendance.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jAttendanceSetup.vue